import { useSelector } from "react-redux";

/**
 * Displays a fixed bottom-left popup when a new version of the app is available.
 * The user must do a hard refresh to load the new assets — dismissing only
 * suppresses the banner for the rest of the current session.
 */
export function VersionUpdateBanner() {
  const { updateAvailable } = useSelector((state) => state.admin);

  if (!updateAvailable) return null;

  const handleRefresh = () => {
    // force=true bypasses the cache and fetches fresh assets from the server
    window.location.reload(true);
  };

  return (
    <>
      <style>{`
        @keyframes slideUpBanner {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0);    }
        }
        .version-banner-enter {
          animation: slideUpBanner 0.3s ease-out both;
        }
      `}</style>

      <div
        role="alert"
        aria-live="polite"
        className="version-banner-enter fixed bottom-20 left-4 z-[9999] w-72 bg-white rounded-xl shadow-2xl border border-gray-200 p-4"
      >
        {/* Header row */}
        <div className="flex items-center justify-between mb-1">
          <div className="flex items-center gap-2">
            <span className="text-base" aria-hidden="true">
              🔄
            </span>
            <span className="text-sm font-semibold text-gray-800">
              Update Available
            </span>
          </div>
        </div>

        {/* Sub-text */}
        <p className="text-xs text-gray-500 mb-3">
          A new version has been deployed. Refresh to load the latest.
        </p>

        {/* Action button */}
        <button
          onClick={handleRefresh}
          className="w-full bg-blue-500 hover:bg-blue-600 active:bg-blue-700 text-white text-sm font-medium py-1.5 px-3 rounded-lg transition-colors"
        >
          Refresh Now
        </button>
      </div>
    </>
  );
}

export default VersionUpdateBanner;
